import '../styles/PageHero.scss';

/**
 * PageHero — reusable full-width hero banner with a background image,
 * cinematic gradient overlay, and inset vignette shadow.
 *
 * Props:
 *   children        — any React content rendered inside the hero
 *   backgroundImage — URL of the bg image  (default: /img/generic-hero-bg.jpg)
 *   minHeight       — CSS min-height value  (default: '220px')
 *   className       — extra class on the root element
 */
const PageHero = ({
    children,
    backgroundImage = '/img/generic-hero-bg.jpg',
    minHeight = '220px',
    className = '',
}) => (
    <div
        className={`page-hero ${className}`.trim()}
        style={{ backgroundImage: `url(${backgroundImage})`, minHeight }}
    >
        {/* Cinematic overlay: gradient + radial vignette */}
        <div className="page-hero__overlay" aria-hidden="true" />

        {/* Content */}
        <div className="page-hero__content container-lg px-3 px-lg-4">
            {children}
        </div>
    </div>
);

export default PageHero;
